import { defineComponent as _defineComponent } from 'vue';
import { useSearchWizardStore } from '#imports';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterAndSortFacetsGroupDefault',
  props: {
    group: null,
    counts: null,
    initialFacetCounts: null,
    selectedFacets: null
  },
  setup(__props) {
    var props = __props;
    var searchWizardStore = useSearchWizardStore(usePinia());
    function isFacetActive(slug) {
      // it's active if it has a count, or we aren't showing any counts
      return !searchWizardStore.showCount || !!props.counts[slug] || props.selectedFacets.includes(slug);
    }
    var facets = computed(() => props.group.facets);
    return {
      __sfc: true,
      props,
      searchWizardStore,
      isFacetActive,
      facets
    };
  }
});